import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

// 取得系統閾值設定
export function getCampaignThresholdConfiguration(
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: "/systems/campaign-threshold-configuration/",
        method: "get",
        ...config,
    })
}

// 更新系統閾值設定
export function updateCampaignThresholdConfiguration(
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: "/systems/campaign-threshold-configuration/",
        method: "put",
        ...config,
    })
}
